export const NAVIGATION_CHANNEL = 'navigation';

export const ANALYTICS_CONTEXT: {
	readonly componentName: 'atlassianAccountMenu';
	readonly packageName: string | undefined;
	readonly packageVersion: string | undefined;
	readonly source: 'atlassianAccountMenu';
} = {
	source: 'atlassianAccountMenu',
	componentName: 'atlassianAccountMenu',
	packageName: process.env._PACKAGE_NAME_,
	packageVersion: process.env._PACKAGE_VERSION_,
} as const;
